import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import Notification from "../../elements/notification/Notification";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import FeeFilter from "./FeeFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import FeeList from "./FeeList";
import { Helmet } from "react-helmet-async";
import FeeExportButton from "../../elements/fee/FeeExportButton";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledFeeWrapper } from "../styledFee";
import { parseAxiosError } from "../../../utils/response";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const FeeContainer = () => {
  const { t } = useTranslation("feePage");

  const history = useHistory();

  const [fees, setFees] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "fee", false, true),
    "baseFee.service.name": checkFilterItem(history, "baseFee.service.name", null),
    "baseFee.paymentSystem.name": checkFilterItem(history, "baseFee.paymentSystem.name", null),
    "baseFee.currency.asset": checkFilterItem(history, "baseFee.currency.asset", null),
    "baseFee.type": checkFilterItem(history, "baseFee.type", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
    "min[gte]": checkFilterItem(history, "min[gte]", null, true),
    "min[lte]": checkFilterItem(history, "min[lte]", null, true),
    "max[gte]": checkFilterItem(history, "max[gte]", null, true),
    "max[lte]": checkFilterItem(history, "max[lte]", null, true)
  });

  const [totalPageCount, setTotalPageCount] = useState(null);

  const fetchFeesList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/fees" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK && "hydra:member" in response.data) {
        setFees(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchFeesList();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  if (!fees) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledFeeWrapper>
          <div className="fee-head">
            <div className="fee-head__left">
              <FeeFilter
                filterData={filterData}
                setFilterData={setFilterData}
              />

              <FeeExportButton
                filterData={filterData}
              />

              <ItemsPerPageSelect
                itemsPerPage={filterData.itemsPerPage}
                setItemsPerPage={(data) => setFilterData({
                  ...filterData,
                  "itemsPerPage": data,
                  page: 1
                })}
              />
            </div>
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />

          <FeeList
            fees={fees}
          />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />
          }
        </StyledFeeWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default FeeContainer;